import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_wm6y8mxhzu: FaireCollectionEntity = {
  token: "pbc_wm6y8mxhzu",
  type: "collection",
  name: "Cropped Jeans",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fbbd60fae0a1d55655a29efd6a9f690212f26eea037e2e51ca4069b1c2767f02.jpeg",
  itemCount: 28,
  description:
    "Cropped wide leg and ankle cropped styles are some of our best selling styles!",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:15.121Z",
    importedBy: "entity-db-import-collections",
  },
};
